<div class="relative px-3 py-2 md:px-6 md:py-4 bg-slate-50/50 dark:bg-slate-900/50 transition-all duration-300"
    [ngClass]="showAuditDetail() ? 'h-[calc(100vh-6rem)] flex flex-col overflow-hidden' : 'min-h-screen'">
    @if (!showAuditDetail()) {

    <!-- Header Section -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
        <h1 class="text-2xl font-bold text-slate-800 dark:text-slate-100 tracking-tight">Call Quality</h1>
    </div>
    <div class="flex justify-between gap-4 mb-5">
        <div class="flex items-center gap-2">
            <app-dropdown [options]="agentOptions()" [selectedValue]="selectedAgent()" placeholder="All Agents"
                [searchable]="true" [searchPlaceholder]="'Search Agent'" [customWidth]="'180px'"
                (selectionChange)="onAgentChange($event)" variant="default"
                iconClass="text-purple-600 dark:text-purple-400"
                textClass="text-slate-600 dark:text-slate-300 font-semibold" [iconName]="'headset'"
                class="relative z-50" [disabled]="isLoading()">
            </app-dropdown>

            <!-- <app-dropdown [options]="teamOptions()" [selectedValue]="selectedTeam()" placeholder="All Teams"
                        [customWidth]="'180px'" (selectionChange)="onTeamChange($event)" variant="default"
                        iconClass="text-purple-600 dark:text-purple-400"
                        textClass="text-slate-600 dark:text-slate-300 font-semibold" [iconName]="'users'" class="relative z-40"
                        [disabled]="isLoading()">
                    </app-dropdown> -->

            <app-dropdown [options]="ratingOptions()" [selectedValue]="selectedRating()" placeholder="All Ratings"
                [customWidth]="'160px'" (selectionChange)="onRatingChange($event)" variant="default"
                iconClass="text-purple-600 dark:text-purple-400"
                textClass="text-slate-600 dark:text-slate-300 font-semibold" [iconName]="'star'" class="relative z-30"
                [disabled]="isLoading()">
            </app-dropdown>

            <app-dropdown [options]="callTypeOptions()" [selectedValue]="selectedCallType()" placeholder="Call Type"
                [customWidth]="'160px'" (selectionChange)="onCallTypeChange($event)" variant="default"
                iconClass="text-purple-600 dark:text-purple-400"
                textClass="text-slate-600 dark:text-slate-300 font-semibold" [iconName]="'headset'"
                class="relative z-30" [disabled]="isLoading()">
            </app-dropdown>

            <app-dropdown [options]="platformOptions()" [selectedValue]="selectedPlatform()" placeholder="Platform"
                [customWidth]="'160px'" (selectionChange)="onPlatformChange($event)" variant="default"
                iconClass="text-purple-600 dark:text-purple-400"
                textClass="text-slate-600 dark:text-slate-300 font-semibold" [iconName]="'audio-lines'"
                class="relative z-30" [disabled]="isLoading()">
            </app-dropdown>

            <app-toggle [checked]="isTest()" [label]="'Dummy'" (toggleChange)="onDummyToggleChange($event)"
                [size]="'sm'" [disabled]="isLoading()">
            </app-toggle>

            @if (hasActiveFilters()) {
            <button (click)="resetFilters()" [disabled]="isLoading()"
                class="h-10 px-4 md:px-5 flex items-center justify-center rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-[13px] md:text-sm font-semibold text-blue-500 hover:bg-blue-50 dark:hover:bg-slate-700 hover:text-blue-600 dark:hover:text-blue-400 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed">
                Reset
            </button>
            }
        </div>
        <div>
            @if (calls().length > 0 && isDenefits()) {
            <button (click)="toggleChat()"
                class="gradient-border h-9 px-4 md:px-5 flex items-center justify-center rounded-xl text-slate-700 dark:text-white text-[13px] md:text-sm font-semibold transition-all duration-200 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_7px_12px_-5px_#AD46FF] gap-2 cursor-pointer">
                <app-icon name="sparkles" [size]="16" />
                Ask Prism AI
            </button>
            }
        </div>

    </div>

    <!-- Content Table (Always Visible, Responsive Columns) -->
    <div
        class="bg-white dark:bg-surface-0 rounded-3xl border border-slate-200 dark:border-slate-800 shadow-xl shadow-slate-200/50 dark:shadow-none overflow-hidden relative min-h-[400px]">


        @if (isLoading()) {
        <div
            class="absolute inset-0 bg-white/60 dark:bg-surface-0/60 backdrop-blur-sm z-50 flex items-center justify-center">
            <div class="flex flex-col items-center gap-4">
                <div class="w-10 h-10 border-4 border-purple-600 border-t-transparent rounded-full animate-spin"></div>
                <p class="text-slate-600 dark:text-slate-400 font-bold animate-pulse">Fetching Call Reports...</p>
            </div>
        </div>
        }

        <div class="p-4 lg:p-6" [ngClass]="{'opacity-50 pointer-events-none': isLoading()}">
            @if (!isLoading() && calls().length === 0) {
            <div class="py-20 flex flex-col items-center justify-center text-center">
                <div
                    class="w-20 h-20 mb-6 bg-slate-50 dark:bg-slate-900/50 rounded-3xl flex items-center justify-center text-slate-300 dark:text-slate-700">
                    <app-icon-v2 name="FileQuestion" [size]="48"></app-icon-v2>
                </div>
                <h3 class="text-xl font-bold text-slate-800 dark:text-slate-200 mb-2">No Reports Found</h3>
                <p class="text-slate-500 dark:text-slate-400 max-w-sm">We couldn't find any call audit reports. They
                    might still be processing or no calls matched your filters.</p>
            </div>
            } @else {
            <app-paginated-table [tableData]="calls()" [headers]="tableHeaders" [totalItems]="totalItems()"
                [backdropBlurClass]="'backdrop-blur-sm'" [pageSize]="pageSize()" [currentPage]="currentPage()"
                [serverSide]="true" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)"
                [tableActionOptions]="tableActionOptions" [isCheckboxShow]="false" [cellTemplates]="{
                    business: businessTemplate,
                    callType: callTypeTemplate,
                    agent: agentTemplate,
                    rating: ratingTemplate,
                    recording: recordingTemplate,
                    audit: auditTemplate
                }"></app-paginated-table>
            }
        </div>
    </div>

    <!-- Chatbot Sidebar (Slide Panel Mode) -->
    <app-slide-panel [open]="isChatOpen()" title="" [showClose]="false" backdropBlurClass="backdrop-blur-none"
        [containerClass]="chatLayoutMode() === 'fullscreen' ? 'full-screen-panel-container' : 'sidebar-panel-container'"
        (closed)="closeChat()" [panelClass]="chatLayoutMode() === 'floating' 
            ? 'min-w-[460px] max-w-[600px] h-screen bg-white dark:bg-surface-1 border-l border-gray-100 dark:border-gray-800' 
            : 'w-screen h-screen bg-white dark:bg-surface-1 border-none'" contentClass="p-0">

        <div class="flex flex-row overflow-hidden h-full">
            <!-- Sidebar (Chat History) -->
            <div class="h-full border-r border-slate-50 dark:border-slate-800/50 bg-[#F8FAFC] dark:bg-surface-1 flex flex-col shrink-0 transition-all duration-300"
                [ngStyle]="{ 'width': isChatHistoryOpen() ? '240px' : '0px', 'opacity': isChatHistoryOpen() ? '1' : '0' }">

                <div class="px-4 py-4 border-b border-slate-100 dark:border-slate-800/50 flex items-center justify-between shrink-0 h-[69px]"
                    [style.display]="isChatHistoryOpen() ? 'flex' : 'none'">
                    <h3 class="text-[13px] font-bold text-slate-800 dark:text-slate-200">Chat History</h3>
                    <button (click)="toggleChatHistory()"
                        class="p-1 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors rounded-lg">
                        <app-icon name="x" [size]="16"></app-icon>
                    </button>
                </div>

                <app-chat-history-sidebar [chatType]="'CALL_AUDIT_HISTORY'"
                    [style.display]="isChatHistoryOpen() ? 'block' : 'none'"
                    (sessionSelected)="onSessionSelected($event)"
                    (newChatRequested)="onNewChatRequested()"></app-chat-history-sidebar>
            </div>

            <!-- Main Chat Area Container -->
            <div class="flex flex-col flex-1 h-full min-w-0 transition-all duration-300">
                <!-- Header (Restored Original) -->
                <div
                    class="px-5 py-4 flex items-center justify-between shrink-0 bg-white dark:bg-surface-1 border-b border-slate-50 dark:border-slate-800/50">
                    <div class="flex items-center gap-3">
                        <div (click)="toggleChatHistory()"
                            class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-all cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/30 rounded-full">
                            <app-icon-v2 name="Menu" [size]="20" />
                        </div>
                        <div class="flex items-center gap-2">
                            <div
                                class="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 dark:bg-blue-900/20 dark:text-blue-400">
                                <app-icon name="sparkles" [size]="16"></app-icon>
                            </div>
                            <div>
                                <h3 class="text-[14px] font-bold text-gray-900 dark:text-white leading-tight">Business
                                    Intelligence Hub</h3>
                                <div class="flex items-center gap-1.5 mt-0.5">
                                    <span
                                        class="w-1.5 h-1.5 rounded-full bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.4)]"></span>
                                    <span
                                        class="text-[10px] font-semibold text-gray-400 dark:text-gray-500">Online</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        <button (click)="toggleLayoutMode()"
                            class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-all cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/30 rounded-full">
                            <app-icon-v2 [name]="chatLayoutMode() === 'floating' ? 'Maximize' : 'Minimize'"
                                [size]="18"></app-icon-v2>
                        </button>
                        <button (click)="closeChat()"
                            class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-all cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/30 rounded-full">
                            <app-icon name="x" [size]="18"></app-icon>
                        </button>
                    </div>
                </div>

                <!-- Popover Body -->
                <div class="flex-1 overflow-hidden relative">
                    <!-- Initial Welcome State (Landing UI) -->
                    <div [class.hidden]="hasStartedChat()"
                        class="flex flex-col h-full px-5 pt-4 pb-20 overflow-y-auto custom-scrollbar">
                        <div
                            class="flex flex-col items-center justify-center text-center my-auto text-slate-400 dark:text-slate-500/50">
                            <div
                                class="w-14 h-14 bg-white dark:bg-slate-800/40 rounded-full flex items-center justify-center mb-2 shadow-sm border border-slate-50 dark:border-slate-700/50">
                                <app-icon name="sparkles" [size]="28"></app-icon>
                            </div>
                            <h4
                                class="text-[13px] font-medium text-slate-500 dark:text-slate-400 max-w-[220px] leading-relaxed">
                                Hi, I'm your data assistant, Ask me anything about call quality.
                            </h4>
                        </div>

                        <!-- Suggestions (Restored Box Style) -->
                        <div class="w-full flex flex-col items-start gap-2 px-1 mt-auto">
                            <button (click)="startChat('Contract Types Performance')"
                                class="w-full px-3.5 py-2.5 rounded-xl border border-gray-100 dark:border-gray-800 hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-all text-left group cursor-pointer shadow-sm hover:shadow-md flex items-center gap-2">
                                <app-icon name="undo2" [size]="12" class="text-slate-400 rotate-90"></app-icon>
                                <span class="text-[12px] font-semibold text-slate-700 dark:text-slate-300">Contract
                                    Types Performance</span>
                            </button>
                            <button (click)="startChat('Industry Performance')"
                                class="w-full px-3.5 py-2.5 rounded-xl border border-gray-100 dark:border-gray-800 hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-all text-left group cursor-pointer shadow-sm hover:shadow-md flex items-center gap-2">
                                <app-icon name="undo2" [size]="12" class="text-slate-400 rotate-90"></app-icon>
                                <span class="text-[12px] font-semibold text-slate-700 dark:text-slate-300">Industry
                                    Performance</span>
                            </button>
                            <button (click)="startChat('Business Growth Analysis')"
                                class="w-full px-3.5 py-2.5 rounded-xl border border-gray-100 dark:border-gray-800 hover:bg-slate-50 dark:hover:bg-slate-800/30 transition-all text-left group cursor-pointer shadow-sm hover:shadow-md flex items-center gap-2">
                                <app-icon name="undo2" [size]="12" class="text-slate-400 rotate-90"></app-icon>
                                <span class="text-[12px] font-semibold text-slate-700 dark:text-slate-300">Business
                                    Growth Analysis</span>
                            </button>
                        </div>

                        <!-- Hub Footer / Input -->
                        <div class="pt-3 pb-4">
                            <div
                                class="relative bg-slate-50 dark:bg-surface-1 rounded-2xl px-3.5 py-3 pr-12 border border-slate-200 dark:border-slate-800/60 group focus-within:border-sky-400 dark:focus-within:border-purple-500/50 transition-all min-h-[110px] flex items-start shadow-inner mb-2">
                                <textarea [(ngModel)]="userInputHub"
                                    (keydown.enter)="$event.preventDefault(); startChat()"
                                    placeholder="What would you like to know?" rows="4"
                                    class="w-full bg-transparent border-none focus:ring-0 text-slate-700 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500 resize-none text-sm p-0 outline-none scrollbar-hide"></textarea>

                                <button (click)="startChat()"
                                    class="absolute bottom-2.5 right-2.5 w-9 h-9 rounded-full border-2 border-l-purple-500 border-r-cyan-500 border-t-cyan-500 border-b-cyan-500 dark:border-l-pink-400 dark:border-r-sky-400 dark:border-t-sky-400 dark:border-b-sky-400 flex items-center justify-center text-white shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all duration-200 cursor-pointer">
                                    <app-icon class="text-purple-500 dark:text-pink-400" name="arrowRight"
                                        [size]="18" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Chat UI -->
                    <app-ai-chat-panel [class.hidden]="!hasStartedChat()" [layoutMode]="chatLayoutMode()"
                        [chatType]="'CALL_AUDIT_HISTORY'" (fullscreenChartRequested)="setLayoutMode('fullscreen')"
                        class="h-full block"></app-ai-chat-panel>
                </div>
            </div>
        </div>
    </app-slide-panel>


    <!-- Column Templates -->
    <ng-template #businessTemplate let-row>
        <div class="flex flex-col gap-0.5 py-1">
            <div class="font-bold text-slate-800 dark:text-slate-100 text-[13px] lg:text-[15px] leading-snug">
                {{ row.business.name }}</div>
            <div class="text-xs lg:text-sm font-semibold text-slate-500 dark:text-slate-400">{{
                row.business.doctor }}</div>
            <div class="flex flex-col gap-0.5 mt-1">
                <div class="text-[11px] lg:text-[12px] font-medium text-slate-400 dark:text-slate-500">
                    {{ row.business.phone }}
                </div>
                <div
                    class="text-[11px] lg:text-[12px] font-medium text-slate-400 dark:text-slate-500 hover:text-purple-600 dark:hover:text-white transition-colors cursor-pointer">
                    {{ row.business.email }}
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #callTypeTemplate let-row>
        <div class="flex flex-col gap-0.5 py-1">
            <div class="font-bold text-slate-800 dark:text-slate-100 text-[13px] lg:text-[15px]">{{
                row.callType.type }}</div>
            <div class="text-xs lg:text-sm font-semibold text-slate-500 dark:text-slate-400">{{
                row.callType.platform }}</div>
            <div class="text-[11px] lg:text-[12px] font-medium text-slate-400 dark:text-slate-500 mt-1">{{
                row.callType.dateTime | date:'MM/dd/yyyy h:mm a':'PDT' }}</div>
        </div>
    </ng-template>

    <ng-template #agentTemplate let-row>
        <div class="flex flex-col gap-0.5 py-1">
            <div class="font-bold text-slate-800 dark:text-slate-100 text-[13px] lg:text-[15px]">
                {{ row.agent.name }}
            </div>
            <div class="text-xs lg:text-sm font-semibold text-slate-500 dark:text-slate-400">
                {{ row.agent.team }}
            </div>
        </div>
    </ng-template>

    <ng-template #ratingTemplate let-row>
        <div class="flex flex-col gap-1.5 py-1">
            <div class="font-bold text-slate-800 dark:text-slate-100 text-[13px] lg:text-[15px]">
                {{ row.rating.score }}
            </div>
            <div class="flex items-center gap-0.5">
                <ng-container *ngFor="let star of getStars(row.rating.stars)">
                    <app-icon-v2 name="Star" [size]="14"
                        [customClass]="star === 1 ? 'fill-amber-400 text-amber-400' : (star === 0.5 ? 'fill-amber-400/30 text-amber-400' : 'text-slate-200 dark:text-slate-700')">
                    </app-icon-v2>
                </ng-container>
            </div>
        </div>
    </ng-template>

    <ng-template #recordingTemplate let-row>
        <div class="max-w-[200px]">
            <div
                class="inline-flex items-center gap-2 bg-slate-50 dark:bg-slate-900/50 border border-slate-100 dark:border-slate-700 rounded-full pl-2 pr-3 py-1.5 transition-all duration-300 w-fit">
                <button (click)="$event.stopPropagation(); playCall(row)"
                    class="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400 hover:bg-purple-600 hover:text-white dark:hover:bg-purple-500 dark:hover:text-white transition-all duration-300 shadow-sm play-record-btn cursor-pointer">
                    <app-icon-v2 [name]="activePlayingCall()?.id === row.id && isPlaying() ? 'Pause' : 'Play'"
                        [size]="15" customClass="fill-current"></app-icon-v2>
                </button>
                <div class="flex items-center gap-2">
                    <div (click)="activePlayingCall()?.id === row.id && seek($event)"
                        class="w-12 lg:w-16 xl:w-24 h-1 bg-slate-200 dark:bg-slate-700 rounded-full relative cursor-pointer">
                        <!-- Progress Circle (Unfilled) -->
                        <div class="absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 border-2 border-purple-500 bg-white dark:bg-slate-900 rounded-full -ml-1 transition-all duration-300 z-10 shadow-sm"
                            [style.left.%]="activePlayingCall()?.id === row.id ? (currentTime() / audioDuration()) * 100 : row.recording.progress">
                        </div>
                        <!-- Filled Track (Subtle) -->
                        <div class="absolute left-0 top-0 h-full bg-purple-500/10 dark:bg-purple-500/10 rounded-full transition-all duration-300"
                            [style.width.%]="activePlayingCall()?.id === row.id ? (currentTime() / audioDuration()) * 100 : row.recording.progress">
                        </div>
                    </div>
                    <app-icon-v2 name="Volume2" [size]="14"
                        customClass="text-slate-500 dark:text-slate-400 ml-1"></app-icon-v2>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #auditTemplate let-row>
        <div class="flex items-center justify-end gap-2 py-1">
            <button (click)="openTranscript(row)"
                class="p-2 text-slate-400 dark:text-slate-500 hover:text-purple-600 dark:hover:text-white hover:bg-purple-50 dark:hover:bg-white/10 rounded-xl transition-all duration-300 cursor-pointer">
                <app-icon-v2 name="FileText" [size]="20"></app-icon-v2>
            </button>
            <button (click)="openAuditDetail(row)"
                class="bg-purple-600 dark:bg-purple-700 text-white px-3 lg:px-5 py-2 lg:py-2.5 rounded-xl lg:rounded-2xl text-[12px] lg:text-[13px] font-bold hover:bg-purple-700 dark:hover:bg-purple-600 hover:shadow-lg hover:shadow-purple-200 dark:hover:shadow-none active:scale-95 transition-all duration-300 whitespace-nowrap">
                Audit Summary
            </button>
        </div>
    </ng-template>
    } @else {
    <!-- Audit Summary Detail View -->
    <div class="w-full max-w-[1536px] mx-auto animate-in fade-in slide-in-from-bottom-5 duration-500 flex flex-col flex-1 min-h-0">

        <ng-template #actionButtons>
            @if (activeAuditCall().isVerified) {
            <div
                class="flex items-center justify-center gap-1.5 px-3 py-1.5 bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 rounded-lg text-xs font-bold border border-green-100 dark:border-green-500/20">
                <app-icon-v2 name="circle-check" [size]="14"></app-icon-v2>
                Verified{{ activeAuditCall().verifiedByName ? ' by ' + activeAuditCall().verifiedByName : '' }}
            </div>
            } @else {
            <button (click)="markAsVerified()" title="You must start the audit to mark it as verified."
                [disabled]="!isTimerRunning() || (activeSession() && activeSession().userPid !== authService.getUserPid())"
                class="flex items-center justify-center gap-1.5 px-3 py-1.5 bg-green-600 text-white rounded-lg text-xs font-bold hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm cursor-pointer">
                <!-- <app-icon-v2 name="circle-check" [size]="14"></app-icon-v2> -->
                Mark as Verified
            </button>
            }
            <button (click)="downloadReport()"
                class="flex items-center justify-center gap-1.5 px-3 py-1.5 bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400 rounded-lg text-xs font-bold hover:bg-purple-100 transition-all border border-purple-100 dark:border-purple-500/20 shadow-sm cursor-pointer">
                <app-icon-v2 name="Download" [size]="14"></app-icon-v2>
                Download Report
            </button>
            <button (click)="openFeedbackModal()"
                class="flex items-center justify-center gap-1.5 px-3 py-1.5 bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400 rounded-lg text-xs font-bold hover:bg-purple-100 transition-all border border-purple-100 dark:border-purple-500/20 shadow-sm cursor-pointer">
                <app-icon-v2 name="MessageSquare" [size]="14"></app-icon-v2>
                Provide Feedback
            </button>
        </ng-template>

        <!-- Active Session / Timer Banner -->
        @if (activeAuditCall()?.isVerified) {
        <div class="mb-4 flex justify-end shrink-0">
            <div class="flex items-center gap-2">
                <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            </div>
        </div>
        } @else {
        @if (activeSession() && activeSession().userPid !== authService.getUserPid()) {
        <div
            class="mb-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-500/30 text-amber-800 dark:text-amber-300 px-4 py-3 rounded-xl flex items-center justify-between shadow-sm shrink-0">
            <div class="flex items-center gap-2 font-medium text-sm">
                <app-icon-v2 name="lock" [size]="16"></app-icon-v2>
                <span>Agent <strong>{{ activeSession().userName || activeSession().userEmail }}</strong> is auditing
                    currently@if (hasSessionAccess()) { for <strong class="tabular-nums">{{ otherAgentElapsedTime()
                        }}</strong>}.</span>
            </div>
            <div class="flex items-center gap-2">
                <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            </div>
        </div>
        } @else if (isTimerRunning()) {
        <div
            class="mb-4 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-500/30 text-indigo-800 dark:text-indigo-300 px-4 py-3 rounded-xl flex items-center justify-between shadow-sm shrink-0">
            <div class="flex items-center gap-2 font-medium text-sm">
                <app-icon-v2 name="clock" [size]="16" class="animate-pulse"></app-icon-v2>
                <span>Auditing</span>
            </div>
            <div class="flex items-center gap-2">
                <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            </div>
        </div>
        } @else {
        <div class="mb-4 flex justify-end shrink-0">
            <div class="flex items-center gap-2">
                <button (click)="startAuditSession()" [disabled]="isStartingSession() || isFetchingSession()"
                    class="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1.5 rounded-lg text-xs font-bold transition-colors shadow-sm cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                    @if (isStartingSession()) {
                    Starting...
                    } @else if (isFetchingSession()) {
                    Checking...
                    } @else {
                    Start Audit
                    }
                </button>
                <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            </div>
        </div>
        }
        }

        <div class="flex flex-col xl:flex-row gap-4 xl:gap-6 items-start flex-1 min-h-0">
            <!-- Left Sidebar (Business Info) -->
            <div
                class="xl:w-[320px] shrink-0 space-y-4 self-start h-full w-full overflow-y-auto scrollbar-hide pb-4">
                <!-- Business Card -->
                <div
                    class="bg-white dark:bg-slate-800 rounded-xl lg:rounded-2xl p-4 border border-slate-100 dark:border-slate-800 shadow-sm">

                    <button (click)="closeAuditDetail()"
                        class="mb-3 -ml-1 flex items-center justify-center p-1.5 rounded-lg text-slate-500 hover:text-slate-800 hover:bg-slate-100 dark:text-slate-400 dark:hover:text-slate-200 dark:hover:bg-slate-700 transition-colors">
                        <app-icon-v2 name="ArrowLeft" [size]="18"></app-icon-v2>
                    </button>

                    <h3 class="text-lg sm:text-xl font-bold text-slate-900 dark:text-white mb-0.5 tracking-tight">
                        {{ activeAuditCall().business.name }}</h3>
                    <p class="text-[12px] font-semibold text-slate-500 dark:text-slate-400 mb-4">{{
                        activeAuditCall().business.doctor }}</p>

                    <div class="pt-4 border-t border-slate-50 dark:border-slate-700/50 mb-4">
                        <div class="flex items-center justify-between mb-1.5">
                            <p
                                class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                                Agent:</p>
                        </div>
                        <div class="flex items-start sm:items-center justify-between flex-wrap gap-2">
                            <div>
                                <p class="text-[12px] font-bold text-slate-900 dark:text-white">{{
                                    activeAuditCall().agent.name }}
                                </p>
                                <div class="flex flex-wrap items-center gap-1.5 mt-0.5">
                                    <span class="text-[11px] font-medium text-slate-500 dark:text-slate-400">{{
                                        activeAuditCall().callType.platform }}</span>
                                    <span
                                        class="text-[11px] font-medium text-slate-400 dark:text-slate-500 opacity-80 pl-1 border-l border-slate-200 dark:border-slate-700">Timing:
                                        {{
                                        activeAuditCall().callType.dateTime | date:'MMM d, yyyy - h:mm a':'PDT'
                                        }}</span>
                                </div>
                            </div>
                            <span
                                class="px-2 py-0.5 bg-purple-50 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400 rounded-full text-[10px] font-bold uppercase tracking-wider border border-purple-100 dark:border-purple-500/20">{{
                                activeAuditCall().callType.type }}</span>
                        </div>
                    </div>

                    <div class="pt-4 border-t border-slate-50 dark:border-slate-700/50">
                        <p
                            class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                            Call Overview:</p>

                        <div class="mb-4">
                            <span class="text-2xl font-bold text-green-600 dark:text-green-400 block">{{
                                activeAuditCall().finalSummary?.weightedScore }}</span>
                            <span
                                class="text-[11px] font-bold text-green-600/70 dark:text-green-400/70 uppercase tracking-tight">Overall
                                Weighted Score</span>
                        </div>

                        <div class="space-y-3 mb-5">
                            <div>
                                <p
                                    class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                                    Contact Type</p>
                                <p class="text-xs font-semibold text-slate-700 dark:text-slate-300">{{
                                    activeAuditCall().callOverview?.contactType || 'Decision Maker (POC)' }}</p>
                            </div>

                            <div>
                                <p
                                    class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                                    Call Type</p>
                                <p class="text-xs font-semibold text-slate-700 dark:text-slate-300">{{
                                    activeAuditCall().callType.type || 'Warm Follow-up / Onboarding' }}</p>
                            </div>

                            <div>
                                <p
                                    class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                                    Conversion Outcome</p>
                                <p class="text-xs font-semibold text-slate-700 dark:text-slate-300">{{
                                    activeAuditCall().finalSummary?.performance || 'Full Conversion - Account
                                    Registered' }}</p>
                            </div>

                            <div>
                                <p
                                    class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                                    Conversion Blockers</p>
                                @if (activeAuditCall().finalSummary?.majorIssues?.length > 0) {
                                <ul class="list-disc pl-4 space-y-1">
                                    @for (issue of activeAuditCall().finalSummary?.majorIssues; track $index) {
                                    <li class="text-xs font-semibold text-slate-700 dark:text-slate-300">{{ issue }}
                                    </li>
                                    }
                                </ul>
                                } @else {
                                <p class="text-xs font-semibold text-slate-700 dark:text-slate-300">None identified.</p>
                                }
                            </div>

                            <div>
                                <p
                                    class="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                                    Executive Summary</p>
                                <p
                                    class="text-xs leading-relaxed text-slate-500 dark:text-slate-400 font-medium italic">
                                    {{ activeAuditCall().overviewSummary || activeAuditCall().callOverview?.summary }}
                                </p>
                            </div>
                        </div>

                        <!-- <div class="flex items-center gap-2 mt-4">
                            <button (click)="closeAuditDetail()"
                                class="flex-1 px-3 py-2 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 rounded-lg text-xs font-bold hover:bg-slate-50 dark:hover:bg-slate-800 transition-all cursor-pointer">
                                Back
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- Main Content (Audit Segments) -->
            <div class="flex-1 flex flex-col space-y-6 min-w-0 self-start h-full w-full overflow-y-auto scrollbar-hide pb-4 pr-1">


                <!-- Recording + Call Transcription (Single Container) -->
                <div
                    class="sticky top-6 shrink-0 z-20 bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-800 shadow-sm overflow-hidden flex flex-col max-h-[calc(100vh-3rem)] recording-player-card">

                    <!-- Recording Player -->
                    <div
                        class="px-4 py-2.5 flex flex-wrap items-center gap-3 sm:gap-4 border-b border-slate-100 dark:border-slate-700 bg-slate-50/30 rounded-t-xl overflow-hidden">
                        <span class="text-sm font-semibold text-slate-800 dark:text-slate-200 shrink-0">Recording</span>
                        <button (click)="$event.stopPropagation(); playCall(activeAuditCall())"
                            class="w-8 h-8 flex items-center justify-center rounded-xl bg-purple-100 dark:bg-purple-900/20 text-purple-600 hover:bg-purple-600 hover:text-white transition-all shadow-sm play-record-btn cursor-pointer">
                            <app-icon-v2
                                [name]="activePlayingCall()?.id === activeAuditCall().id && isPlaying() ? 'Pause' : 'Play'"
                                [size]="14" customClass="fill-current"></app-icon-v2>
                        </button>
                        <div (click)="activePlayingCall()?.id === activeAuditCall().id && seek($event)"
                            class="flex-1 cursor-pointer">
                            <div class="h-2 bg-slate-200 dark:bg-slate-700 rounded-full relative">
                                <!-- Progress Circle (Seeker Thumb) -->
                                <div class="absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 border-2 border-purple-600 bg-white rounded-full -ml-1.5 transition-all duration-300 z-10 shadow-sm"
                                    [style.left.%]="activePlayingCall()?.id === activeAuditCall().id && audioDuration() > 0 ? (currentTime() / audioDuration()) * 100 : 0">
                                </div>
                                <!-- Filled Track -->
                                <div class="absolute inset-y-0 left-0 bg-purple-500 rounded-full transition-all duration-300"
                                    [style.width.%]="activePlayingCall()?.id === activeAuditCall().id && audioDuration() > 0 ? (currentTime() / audioDuration()) * 100 : 0">
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center gap-2 text-slate-500">
                            <span class="text-xs font-semibold tabular-nums text-slate-600 dark:text-slate-300">
                                {{ activePlayingCall()?.id === activeAuditCall().id ? formatTime(currentTime()) :
                                '00:00' }} /
                                {{ activePlayingCall()?.id === activeAuditCall().id ? formatTime(audioDuration()) :
                                formatTime(activeAuditCall().duration) }}
                            </span>
                            <app-icon-v2 name="Volume2" [size]="16"
                                customClass="text-slate-500 dark:text-slate-400"></app-icon-v2>
                        </div>
                        <div class="ml-auto">
                        </div>
                    </div>

                    <!-- Call Transcription Section -->
                    <div class="px-4 py-3 sm:px-5 sm:py-4">
                        <div class="flex items-center justify-between"
                            [ngClass]="{'mb-3 pb-3 border-b border-slate-100 dark:border-slate-700': showTranscriptionInAudit()}">
                            <button (click)="toggleAuditTranscript()"
                                class="flex items-center gap-1.5 text-sm font-bold text-purple-600 dark:text-purple-400 transcript-toggle cursor-pointer">
                                Call Transcription
                                <app-icon-v2 name="ChevronDown" [size]="16"
                                    [customClass]="(showTranscriptionInAudit() ? 'rotate-180 transition-transform' : 'transition-transform') + ' text-purple-600 dark:text-purple-400'"></app-icon-v2>
                            </button>
                            <button (click)="downloadTranscript()"
                                class="flex items-center gap-1.5 text-purple-600 dark:text-purple-400 font-semibold text-xs hover:text-purple-700 transition-colors cursor-pointer">
                                <app-icon-v2 name="Download" [size]="14"
                                    customClass="text-purple-600 dark:text-purple-400"></app-icon-v2>
                                Download
                            </button>
                        </div>
                        @if (showTranscriptionInAudit()) {
                        <!-- Transcript Content -->
                        <div #auditTranscriptContainer
                            class="max-h-[350px] overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-slate-200 dark:scrollbar-thumb-slate-700 scrollbar-track-transparent [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-slate-200 dark:[&::-webkit-scrollbar-thumb]:bg-slate-700 [&::-webkit-scrollbar-thumb]:rounded-full">
                            @for (msg of activeAuditCall().formattedTranscript; track $index) {
                            <div [id]="'audit-row-' + $index"
                                class="py-2.5 px-3 rounded-xl border-b border-slate-100 dark:border-slate-800 last:border-0 space-y-1 animate-in fade-in slide-in-from-bottom-2 duration-300 transition-all"
                                [ngClass]="{
                                    'opacity-50': activePlayingCall()?.id === activeAuditCall()?.id && msg.timeSeconds > currentTime(),
                                    'bg-indigo-50/30 dark:bg-indigo-950/20': msg.role === 'AGENT',
                                    'bg-purple-50/30 dark:bg-purple-950/20': msg.role === 'AI'
                                }">
                                <div class="flex items-center gap-2">
                                    <span class="text-[14px] font-bold" [class.text-indigo-600]="msg.role === 'AGENT'"
                                        [class.dark:text-indigo-400]="msg.role === 'AGENT'"
                                        [class.text-purple-600]="msg.role === 'AI'"
                                        [class.dark:text-purple-400]="msg.role === 'AI'"
                                        [class.text-blue-600]="msg.role === 'CUSTOMER'"
                                        [class.dark:text-blue-400]="msg.role === 'CUSTOMER'"
                                        [class.text-slate-900]="!['AGENT', 'AI', 'CUSTOMER'].includes(msg.role)"
                                        [class.dark:text-white]="!['AGENT', 'AI', 'CUSTOMER'].includes(msg.role)">
                                        {{ msg.speaker }}:
                                    </span>
                                    <span class="text-slate-400 font-medium text-[11px] tabular-nums">[{{ msg.time
                                        }}]</span>
                                </div>
                                <p class="text-[14px] leading-relaxed transition-colors"
                                    [ngClass]="activePlayingCall()?.id === activeAuditCall()?.id && msg.timeSeconds <= currentTime() ? 'text-slate-900 dark:text-white font-bold' : 'text-slate-600 dark:text-slate-300'">
                                    {{ msg.text }}
                                </p>
                            </div>
                            } @empty {
                            <div
                                class="py-8 flex flex-col items-center justify-center text-center opacity-40 select-none">
                                <app-icon-v2 name="FileText" [size]="32" customClass="mb-2"></app-icon-v2>
                                <p class="text-[14px] font-medium">No transcription data found</p>
                            </div>
                            }
                        </div>
                        } @else if (activePlayingCall()?.id === activeAuditCall()?.id && currentTranscriptIndex() !==
                        -1) {
                        <!-- Mini Preview (Collapsed State) -->
                        <div class="space-y-4 animate-in fade-in duration-300">
                            @let currentIndex = currentTranscriptIndex();
                            @let currentMsg = activeAuditCall().formattedTranscript[currentIndex];
                            @let nextMsg = activeAuditCall().formattedTranscript[currentIndex + 1];

                            <!-- Active Line -->
                            @if (currentMsg) {
                            <div class="space-y-1">
                                <div class="flex items-center gap-2">
                                    <span class="text-[14px] font-bold"
                                        [class.text-indigo-600]="currentMsg.role === 'AGENT'"
                                        [class.dark:text-indigo-400]="currentMsg.role === 'AGENT'"
                                        [class.text-purple-600]="currentMsg.role === 'AI'"
                                        [class.dark:text-purple-400]="currentMsg.role === 'AI'"
                                        [class.text-blue-600]="currentMsg.role === 'CUSTOMER'"
                                        [class.dark:text-blue-400]="currentMsg.role === 'CUSTOMER'"
                                        [class.text-slate-900]="!['AGENT', 'AI', 'CUSTOMER'].includes(currentMsg.role)"
                                        [class.dark:text-white]="!['AGENT', 'AI', 'CUSTOMER'].includes(currentMsg.role)">
                                        {{ currentMsg.speaker }}:
                                    </span>
                                    <span class="text-slate-400 font-medium text-[11px] tabular-nums">[{{
                                        currentMsg.time }}]</span>
                                </div>
                                <p class="text-[14px] font-bold text-slate-900 dark:text-white leading-relaxed">
                                    {{ currentMsg.text }}
                                </p>
                            </div>
                            }

                            <!-- Next Line (Faded) -->
                            @if (nextMsg) {
                            <div class="space-y-1 opacity-50">
                                <div class="flex items-center gap-2">
                                    <span class="text-[14px] font-bold"
                                        [class.text-indigo-600]="nextMsg.role === 'AGENT'"
                                        [class.dark:text-indigo-400]="nextMsg.role === 'AGENT'"
                                        [class.text-purple-600]="nextMsg.role === 'AI'"
                                        [class.dark:text-purple-400]="nextMsg.role === 'AI'"
                                        [class.text-blue-600]="nextMsg.role === 'CUSTOMER'"
                                        [class.dark:text-blue-400]="nextMsg.role === 'CUSTOMER'"
                                        [class.text-slate-400]="!['AGENT', 'AI', 'CUSTOMER'].includes(nextMsg.role)">
                                        {{ nextMsg.speaker }}:
                                    </span>
                                    <span class="text-slate-300 font-medium text-[11px] tabular-nums">[{{ nextMsg.time
                                        }}]</span>
                                </div>
                                <p class="text-[14px] font-medium text-slate-400 leading-relaxed">
                                    {{ nextMsg.text }}
                                </p>
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>

                <!-- Scrollable Bottom Section -->
                <div (scroll)="showTranscriptionInAudit() && showTranscriptionInAudit.set(false)"
                    class="flex-1 space-y-6 overflow-y-auto pr-2 pb-4 mt-3 scrollbar-thin scrollbar-thumb-slate-200 dark:scrollbar-thumb-slate-700 scrollbar-track-transparent [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-slate-200 dark:[&::-webkit-scrollbar-thumb]:bg-slate-700 [&::-webkit-scrollbar-thumb]:rounded-full">

                    <!-- Final Summary (Newly Added) -->
                    <div
                        class="bg-white dark:bg-slate-800 rounded-xl lg:rounded-2xl p-5 border border-slate-100 dark:border-slate-800 shadow-sm space-y-5 animate-in fade-in slide-in-from-bottom-2 duration-400 shrink-0">
                        <!-- Overall Score -->
                        <div class="flex items-center gap-3">
                            <div
                                class="w-12 h-12 shrink-0 rounded-2xl bg-green-600 text-white flex flex-col items-center justify-center shadow-lg shadow-green-200 dark:shadow-none">
                                <span class="text-xl font-bold leading-none">{{
                                    activeAuditCall().finalSummary?.weightedScore }}</span>
                                <span
                                    class="text-[7px] font-bold uppercase tracking-wider opacity-90 pt-0.5">Score</span>
                            </div>
                            <h3 class="text-lg font-bold text-slate-800 dark:text-white tracking-tight">Overall Weighted
                                Score</h3>
                        </div>

                        <!-- Key Highlights -->
                        <div class="border-t border-slate-50 dark:border-slate-700/50 pt-4">
                            <p class="text-[14px] font-bold text-slate-500 uppercase tracking-widest mb-3">Key
                                Highlights
                            </p>
                            <div class="space-y-3">
                                @for (h of activeAuditCall().finalSummary?.highlights; track $index) {
                                <div class="space-y-0.5">
                                    <p class="text-[14px] font-medium text-slate-700 dark:text-slate-300 leading-snug">
                                        {{
                                        h.description || h }}</p>
                                </div>
                                }
                            </div>
                        </div>

                        <!-- Overall Performance Evaluation -->
                        <div class="border-t border-slate-50 dark:border-slate-700/50 pt-4">
                            <p class="text-[14px] font-bold text-slate-500 uppercase tracking-widest mb-2">Overall
                                Performance Evaluation</p>
                            <div
                                class="p-4 bg-slate-50 dark:bg-slate-900/40 rounded-xl text-[14px] font-medium text-slate-700 dark:text-slate-300 leading-relaxed border border-slate-100 dark:border-slate-800">
                                {{ activeAuditCall().finalSummary?.performance }}
                            </div>
                        </div>

                        <!-- Top 3 Coaching Priorities -->
                        <div class="border-t border-slate-50 dark:border-slate-700/50 pt-4">
                            <p class="text-[14px] font-bold text-slate-500 uppercase tracking-widest mb-3">Top 3
                                Coaching
                                Priorities</p>
                            <div class="space-y-2">
                                @for (c of activeAuditCall().finalSummary?.coaching; track $index) {
                                <div
                                    class="p-3 bg-amber-50 dark:bg-amber-900/10 rounded-xl border border-amber-200 dark:border-amber-500/20 text-[14px] font-medium text-amber-900 dark:text-amber-200 leading-snug markdown-content">
                                    <markdown [data]="c"></markdown>
                                </div>
                                }
                            </div>
                        </div>

                        <!-- Commentary on Topic Adherence -->
                        <div class="border-t border-slate-50 dark:border-slate-700/50 pt-4">
                            <p class="text-[14px] font-bold text-slate-500 uppercase tracking-widest mb-2">Commentary on
                                Topic Adherence</p>
                            <p class="text-[14px] font-medium text-slate-600 dark:text-slate-400 leading-relaxed">
                                {{ activeAuditCall().finalSummary?.commentary || 'N/A - No topic of the day was provided
                                for this audit.' }}
                            </p>
                        </div>
                    </div>

                    <!-- Category Items -->
                    <div class="space-y-4">
                        @for (cat of auditCategories(); track cat.id) {
                        <div
                            class="bg-white dark:bg-slate-800 rounded-xl lg:rounded-2xl p-4 border border-slate-100 dark:border-slate-800 shadow-sm flex flex-col lg:flex-row gap-4 lg:gap-8">
                            <!-- Category Left Content -->
                            <div class="flex-1 lg:w-1/2 space-y-4">
                                <div class="flex items-center gap-3">
                                    <div
                                        class="w-12 h-12 shrink-0 rounded-xl bg-amber-400 dark:bg-amber-500/20 text-white dark:text-amber-400 flex flex-col items-center justify-center shadow-sm">
                                        <span class="text-lg font-bold leading-none">{{ cat.score }}</span>
                                        <span
                                            class="text-[7px] font-bold uppercase tracking-wider opacity-90 pt-0.5">Score</span>
                                    </div>
                                    <h4
                                        class="text-base sm:text-lg font-bold text-slate-900 dark:text-white tracking-tight">
                                        {{ cat.title }}</h4>
                                </div>

                                <div class="space-y-1.5">
                                    <p class="text-[14px] font-bold text-slate-500 uppercase tracking-widest">
                                        Justification</p>
                                    <div
                                        class="p-3 bg-slate-50 dark:bg-slate-900/40 rounded-lg text-[14px] font-medium text-slate-700 dark:text-slate-300 leading-relaxed border border-slate-100 dark:border-slate-800">
                                        {{ cat.justification }}
                                    </div>
                                </div>

                                <div class="space-y-1.5">
                                    <p class="text-[14px] font-bold text-slate-500 uppercase tracking-widest">
                                        Analysis & Insight</p>
                                    <div class="space-y-1">
                                        <p
                                            class="text-[14px] font-bold text-slate-800 dark:text-white italic leading-snug">
                                            "{{ cat.analysis }}"</p>
                                        <p
                                            class="text-[14px] font-medium text-slate-600 dark:text-slate-400 leading-relaxed">
                                            {{ cat.analysisSub }}</p>
                                    </div>
                                </div>

                                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                                    <div class="space-y-2">
                                        <p class="text-[14px] font-bold text-green-600 uppercase tracking-widest">
                                            What Went Well</p>
                                        <div class="space-y-1.5">
                                            @for (well of cat.wentWell; track well) {
                                            <div
                                                class="flex items-center gap-1.5 text-[14px] text-slate-700 dark:text-slate-200 font-medium">
                                                <app-icon-v2 name="circle-check" [size]="14"
                                                    customClass="text-green-500 dark:text-green-400 shrink-0"></app-icon-v2>
                                                {{ well }}
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    <div class="space-y-2">
                                        <p class="text-[14px] font-bold text-amber-500 uppercase tracking-widest">
                                            Opportunities</p>
                                        <div class="space-y-1.5">
                                            @for (opp of cat.opportunities; track opp) {
                                            <div
                                                class="flex items-start gap-1.5 text-[14px] text-slate-700 dark:text-slate-200 font-medium">
                                                <app-icon-v2 name="Info" [size]="14"
                                                    customClass="text-amber-500 dark:text-amber-400 mt-0.5 shrink-0"></app-icon-v2>
                                                {{ opp }}
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Category Right Panel (Excerpts) -->
                            <div
                                class="flex-1 lg:w-1/2 shrink-0 space-y-3 bg-slate-50 dark:bg-slate-900/50 p-4 lg:p-6 rounded-xl border border-slate-100 dark:border-slate-800">
                                <p
                                    class="text-[14px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">
                                    Conversation Excerpt</p>

                                <div class="space-y-4">
                                    @for (exc of cat.excerpts; track $index) {
                                    <div class="space-y-1">
                                        <p class="text-[14px] font-bold text-slate-800 dark:text-slate-200">
                                            {{ exc.label }}</p>
                                        <div class="text-[14px] leading-relaxed markdown-content" [ngClass]="{
                                        'text-slate-600 dark:text-slate-400': !exc.isWarning && !exc.isSuccess,
                                        'text-red-500 dark:text-red-400': exc.isWarning,
                                        'p-2.5 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 font-medium rounded-lg border border-green-100 dark:border-green-800/30': exc.isSuccess
                                    }">
                                            <markdown [data]="exc.text"></markdown>
                                            @if(exc.time) { <span
                                                class="block mt-0.5 text-[10px] font-medium text-slate-400">{{ exc.time
                                                }}</span> }
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>

                    <!-- Reviewer activity + QA active-time listing (shown below the report) -->
                    @if (hasSessionAccess()) {
                    <app-call-audit-activity-panel [auditId]="$safeNavigationMigration(activeAuditCall()?.id)"></app-call-audit-activity-panel>
                    }
                </div>
            </div>
        </div>
    </div>
    }

    <!-- Recording Player Card (Constrained & Figma-Matched) -->
    @if (activePlayingCall() && !showAuditDetail()) {
    <div class="sticky bottom-10 w-full h-0 pointer-events-none z-[100] recording-player-card">
        <div
            class="absolute bottom-0 right-0 pointer-events-auto w-[min(420px,calc(100%-2.5rem))] bg-white dark:bg-slate-900 rounded-[32px] shadow-[0_20px_60px_rgba(0,0,0,0.2)] border border-slate-100 dark:border-slate-800 overflow-hidden animate-in fade-in slide-in-from-bottom-5 duration-300">

            <!-- Player Header -->
            <div class="px-7 pt-7 pb-5 flex items-start justify-between">
                <div class="flex items-center gap-4">
                    <div
                        class="w-11 h-11 shrink-0 rounded-2xl bg-purple-50 dark:bg-purple-900/20 flex items-center justify-center text-purple-600 dark:text-purple-400">
                        <app-icon-v2 name="Headphones" [size]="22"></app-icon-v2>
                    </div>
                    <div>
                        <h3 class="font-bold text-slate-800 dark:text-white text-[17px] leading-tight">{{
                            activePlayingCall().business.name }}</h3>
                        <div class="flex items-center gap-2 mt-1.5">
                            <span class="text-[12px] font-semibold text-slate-400 dark:text-slate-500">{{
                                activePlayingCall().callType.dateTime | date:'MMM d, yyyy':'PDT' }}</span>
                            <span class="w-1 h-1 rounded-full bg-slate-200 dark:bg-slate-700"></span>
                            <span class="text-[12px] font-bold text-purple-600 dark:text-purple-400">{{
                                activePlayingCall().callType.platform }}</span>
                        </div>
                    </div>
                </div>
                <button (click)="closePlayer()"
                    class="p-1.5 hover:bg-slate-50 dark:hover:bg-slate-800 rounded-lg text-slate-300 dark:text-slate-500 transition-colors">
                    <app-icon-v2 name="X" [size]="20"></app-icon-v2>
                </button>
            </div>

            <!-- Player Controls -->
            <div class="px-7 py-6">
                <div class="flex items-center gap-5">
                    <button (click)="togglePlay()"
                        class="w-12 h-12 shrink-0 flex items-center justify-center rounded-2xl bg-purple-600 text-white shadow-lg shadow-purple-600/30 hover:bg-purple-700 active:scale-95 transition-all cursor-pointer">
                        <app-icon-v2 [name]="isPlaying() ? 'Pause' : 'Play'" [size]="20"
                            customClass="fill-current"></app-icon-v2>
                    </button>
                    <div class="flex-1">
                        <div
                            class="flex items-center justify-between mb-2 text-[11px] font-bold tabular-nums text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                            <span>{{ formatTime(currentTime()) }}</span>
                            <span>{{ audioDuration() > 0 ? formatTime(audioDuration()) : '--:--' }}</span>
                        </div>
                        <div (click)="seek($event)"
                            class="h-1.5 bg-slate-100 dark:bg-slate-800 rounded-full overflow-visible relative group cursor-pointer">
                            <div class="absolute left-0 top-0 h-full bg-purple-500 rounded-full"
                                [style.width.%]="audioDuration() > 0 ? (currentTime() / audioDuration()) * 100 : 0">
                            </div>
                            <!-- Progress Thumb (Circle) -->
                            <div class="absolute w-4 h-4 bg-white border-[3px] border-purple-500 rounded-full shadow-lg top-1/2 -translate-y-1/2 -ml-2 group-hover:scale-110 transition-transform"
                                [style.left.%]="audioDuration() > 0 ? (currentTime() / audioDuration()) * 100 : 0">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Transcript Section -->
            <div #playerTranscriptContainer class="max-h-[280px] overflow-y-auto px-7 pb-8 space-y-6 scrollbar-hide">
                @for (msg of activePlayingCall().formattedTranscript; track $index) {
                <div [id]="'player-row-' + $index" class="py-2.5 px-3 rounded-xl space-y-1.5 transition-all" [ngClass]="{
                        'opacity-30': msg.timeSeconds > currentTime(),
                        'bg-indigo-50/30 dark:bg-indigo-950/20': msg.role === 'AGENT',
                        'bg-purple-50/30 dark:bg-purple-950/20': msg.role === 'AI'
                    }">
                    <div class="flex items-center gap-2">
                        <span class="text-[13px] font-black" [class.text-indigo-600]="msg.role === 'AGENT'"
                            [class.dark:text-indigo-400]="msg.role === 'AGENT'"
                            [class.text-purple-600]="msg.role === 'AI'" [class.dark:text-purple-400]="msg.role === 'AI'"
                            [class.text-blue-600]="msg.role === 'CUSTOMER'"
                            [class.dark:text-blue-400]="msg.role === 'CUSTOMER'"
                            [class.text-slate-900]="!['AGENT', 'AI', 'CUSTOMER'].includes(msg.role)"
                            [class.dark:text-white]="!['AGENT', 'AI', 'CUSTOMER'].includes(msg.role)">
                            {{ msg.speaker }}:
                        </span>
                        <span class="text-[11px] font-bold text-slate-400 dark:text-slate-500 tabular-nums">[{{ msg.time
                            }}]</span>
                    </div>
                    <p class="text-[14px] leading-relaxed transition-colors whitespace-pre-wrap"
                        [ngClass]="msg.timeSeconds <= currentTime() ? 'text-slate-900 dark:text-white font-bold' : 'text-slate-600 dark:text-slate-400 font-medium'">
                        {{ msg.text }}
                    </p>
                </div>
                } @empty {
                <div class="py-10 flex flex-col items-center text-center opacity-30 select-none">
                    <app-icon-v2 name="FileText" [size]="32" customClass="mb-2"></app-icon-v2>
                    <p class="text-sm font-bold">No transcription data found</p>
                </div>
                }
            </div>
        </div>
    </div>
    }

    <!-- Call Transcription Sidebar -->
    @if (activeTranscriptCall()) {
    <div
        class="fixed inset-y-0 right-0 w-full sm:w-[550px] bg-white dark:bg-slate-900 shadow-2xl border-l border-slate-200 dark:border-slate-800 z-[9999] animate-in slide-in-from-right duration-500 ease-out flex flex-col transcript-sidebar">
        <!-- Sidebar Header -->
        <div
            class="px-8 h-[80px] border-b border-slate-100 dark:border-slate-800 flex items-center justify-between bg-white dark:bg-slate-900 shrink-0">
            <span class="text-xl font-bold text-slate-900 dark:text-white">Call Transcription</span>
            <button (click)="closeTranscript()"
                class="w-10 h-10 flex items-center justify-center hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg text-slate-400 dark:text-slate-500 transition-all">
                <app-icon-v2 name="X" [size]="24" [strokeWidth]="2.5"></app-icon-v2>
            </button>
        </div>

        <!-- Scrollable Content -->
        <div
            class="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-slate-200 dark:scrollbar-thumb-slate-700 scrollbar-track-transparent [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-slate-200 dark:[&::-webkit-scrollbar-thumb]:bg-slate-700 [&::-webkit-scrollbar-thumb]:rounded-full">
            <!-- Business Info -->
            <div class="px-8 py-6 bg-slate-50 dark:bg-slate-800/20 border-b border-slate-100 dark:border-slate-800">
                <h3 class="text-xl font-bold text-slate-900 dark:text-white mb-1.5 tracking-tight">{{
                    activeTranscriptCall().business.name }}</h3>
                <div class="flex items-center gap-3">
                    <span class="text-[13px] font-medium text-slate-500 dark:text-slate-400">{{
                        activeTranscriptCall().callType.dateTime | date:'MMM d, yyyy':'PDT' }}</span>
                    <span class="w-1 h-1 rounded-full bg-slate-300 dark:bg-slate-600"></span>
                    <span class="text-[13px] font-medium text-purple-600 dark:text-purple-400">{{
                        activeTranscriptCall().callType.platform }}</span>
                </div>
            </div>

            <!-- Full Transcription List -->
            <div #sidebarTranscriptContainer class="px-8 pb-8 pt-4">
                @for (msg of activeTranscriptCall().formattedTranscript; track $index) {
                <div [id]="'sidebar-row-' + $index"
                    class="py-4 px-4 rounded-xl border-b border-slate-100 dark:border-slate-800 last:border-0 space-y-1.5 group transition-all"
                    [ngClass]="{
                        'opacity-30': activePlayingCall()?.id === activeTranscriptCall()?.id && msg.timeSeconds > currentTime(),
                        'bg-indigo-50/30 dark:bg-indigo-950/20': msg.role === 'AGENT',
                        'bg-purple-50/30 dark:bg-purple-950/20': msg.role === 'AI'
                    }">
                    <div class="flex items-center gap-2">
                        <span class="text-[14px] sm:text-[15px] font-semibold transition-colors"
                            [class.text-indigo-600]="msg.role === 'AGENT'"
                            [class.dark:text-indigo-400]="msg.role === 'AGENT'"
                            [class.text-purple-600]="msg.role === 'AI'" [class.dark:text-purple-400]="msg.role === 'AI'"
                            [class.text-blue-600]="msg.role === 'CUSTOMER'"
                            [class.dark:text-blue-400]="msg.role === 'CUSTOMER'"
                            [class.text-slate-900]="!['AGENT', 'AI', 'CUSTOMER'].includes(msg.role)"
                            [class.dark:text-white]="!['AGENT', 'AI', 'CUSTOMER'].includes(msg.role)">
                            {{ msg.speaker }}:
                        </span>
                        <span class="text-[12px] font-medium text-slate-500 dark:text-slate-400 tabular-nums">[{{
                            msg.time
                            }}]</span>
                    </div>
                    <p class="text-[14px] sm:text-[15px] leading-relaxed transition-colors whitespace-pre-wrap"
                        [ngClass]="activePlayingCall()?.id === activeTranscriptCall()?.id && msg.timeSeconds <= currentTime() ? 'text-slate-900 dark:text-white font-bold' : 'text-slate-600 dark:text-slate-400 group-hover:text-slate-800 dark:group-hover:text-slate-200'">
                        {{ msg.text }}
                    </p>
                </div>
                } @empty {
                <div class="py-20 flex flex-col items-center justify-center text-center opacity-30 select-none">
                    <app-icon-v2 name="FileText" [size]="64" customClass="mb-6"></app-icon-v2>
                    <h3 class="text-2xl font-bold mb-2">No transcription data found</h3>
                    <p class="text-lg font-medium max-w-xs text-slate-400">We couldn't find any transcription for this
                        call recording.</p>
                </div>
                }
            </div>
        </div>
    </div>
    <!-- Backdrop for Sidebar -->
    <div (click)="closeTranscript()"
        class="fixed inset-0 bg-slate-900/10 backdrop-blur-[4px] z-[140] animate-in fade-in duration-300 transcript-backdrop">
    </div>
    }

    <!-- Feedback Modal -->
    @if (isFeedbackModalOpen()) {
    <div class="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6">
        <!-- Backdrop -->
        <div (click)="closeFeedbackModal()"
            class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm animate-in fade-in duration-300"></div>

        <!-- Modal Container -->
        <div
            class="relative w-full max-w-[550px] bg-white dark:bg-surface-1 rounded-[16px] shadow-2xl flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-300 overflow-hidden">
            <!-- Modal Header -->
            <div class="flex items-center justify-between px-6 py-5 shrink-0">
                <div class="flex items-center gap-4">
                    <div
                        class="w-10 h-10 rounded-[10px] bg-[#F3E8FF] dark:bg-purple-900/30 flex items-center justify-center text-[#7C3AED] dark:text-purple-400">
                        <app-icon-v2 name="FilePenLine" [size]="20"></app-icon-v2>
                    </div>
                    <div>
                        <h2 class="text-[16px] font-bold text-slate-900 dark:text-white leading-tight">Provide
                            Feedback</h2>
                        <p class="text-[12px] font-medium text-slate-400 dark:text-slate-500 mt-0.5">Audit Evaluation
                            for {{ activeAuditCall()?.agent?.name || 'John Doe' }}</p>
                    </div>
                </div>
                <button (click)="closeFeedbackModal()"
                    class="p-2 -mr-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 rounded-xl transition-colors cursor-pointer">
                    <app-icon-v2 name="X" [size]="20"></app-icon-v2>
                </button>
            </div>

            <!-- Modal Body -->
            <div
                class="flex-1 overflow-y-auto px-6 py-2 space-y-6 scrollbar-thin scrollbar-thumb-slate-200 dark:scrollbar-thumb-slate-700 bg-white dark:bg-surface-1">
                <!-- Observations -->
                <div class="flex flex-col">
                    <div class="flex items-center justify-between mb-2">
                        <label class="text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wide">
                            OBSERVATIONS <span class="text-[#7C3AED]">*</span>
                        </label>
                        <span class="text-[11px] text-slate-400 font-medium" [class.text-red-500]="feedbackObservations().trim().length > 0 && feedbackObservations().trim().length < 30">{{ feedbackObservations().trim().length }} /
                            250</span>
                    </div>
                    <textarea maxlength="250" [ngModel]="feedbackObservations()"
                        (ngModelChange)="feedbackObservations.set($event)"
                        class="w-full p-4 rounded-[12px] border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 text-[13px] resize-y focus:outline-none focus:border-[#7C3AED] transition-colors min-h-[90px] placeholder:text-slate-400/80 leading-relaxed shadow-sm"
                        [class.!border-red-500]="feedbackObservations().trim().length > 0 && feedbackObservations().trim().length < 30"
                        placeholder="What specific actions or gaps did you observe during this audit?&#10;Be factual and specify timestamps where possible."></textarea>
                    @if (feedbackObservations().trim().length > 0 && feedbackObservations().trim().length < 30) {
                        <span class="text-[11px] text-red-500 mt-1 font-medium">Minimum 30 characters required (without spaces)</span>
                    }
                </div>

                <!-- Recommendations -->
                <div class="flex flex-col">
                    <div class="flex items-center justify-between mb-2">
                        <label class="text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wide">
                            RECOMMENDATIONS <span class="text-[#7C3AED]">*</span>
                        </label>
                        <span class="text-[11px] text-slate-400 font-medium" [class.text-red-500]="feedbackRecommendations().trim().length > 0 && feedbackRecommendations().trim().length < 30">{{ feedbackRecommendations().trim().length }} /
                            250</span>
                    </div>
                    <textarea maxlength="250" [ngModel]="feedbackRecommendations()"
                        (ngModelChange)="feedbackRecommendations.set($event)"
                        class="w-full p-4 rounded-[12px] border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 text-[13px] resize-y focus:outline-none focus:border-[#7C3AED] transition-colors min-h-[90px] placeholder:text-slate-400/80 leading-relaxed shadow-sm"
                        [class.!border-red-500]="feedbackRecommendations().trim().length > 0 && feedbackRecommendations().trim().length < 30"
                        placeholder="Detail the exact steps recommended to resolve or improve the&#10;identified issues"></textarea>
                    @if (feedbackRecommendations().trim().length > 0 && feedbackRecommendations().trim().length < 30) {
                        <span class="text-[11px] text-red-500 mt-1 font-medium">Minimum 30 characters required (without spaces)</span>
                    }
                </div>

                <!-- Additional Notes -->
                <div class="flex flex-col">
                    <div class="flex items-center justify-between mb-2">
                        <label class="text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wide">
                            ADDITIONAL NOTES
                        </label>
                        <span class="text-[11px] text-slate-400 font-medium" [class.text-red-500]="feedbackComments().trim().length > 0 && feedbackComments().trim().length < 30">{{ feedbackComments().trim().length }} /
                            250</span>
                    </div>
                    <textarea maxlength="250" [ngModel]="feedbackComments()"
                        (ngModelChange)="feedbackComments.set($event)"
                        class="w-full p-4 rounded-[12px] border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 text-[13px] resize-y focus:outline-none focus:border-[#7C3AED] transition-colors min-h-[90px] placeholder:text-slate-400/80 leading-relaxed shadow-sm"
                        [class.!border-red-500]="feedbackComments().trim().length > 0 && feedbackComments().trim().length < 30"
                        placeholder="Add secondary context, positive achievements, soft-skills&#10;observations, or any auxiliary remarks (optional)."></textarea>
                    @if (feedbackComments().trim().length > 0 && feedbackComments().trim().length < 30) {
                        <span class="text-[11px] text-red-500 mt-1 font-medium">Minimum 30 characters required (without spaces)</span>
                    }
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="px-6 py-4 bg-white dark:bg-surface-1 shrink-0 flex items-center justify-end gap-2 mt-auto">
                <button (click)="closeFeedbackModal()"
                    class="px-5 py-2.5 text-[13px] font-bold text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white transition-colors cursor-pointer">
                    Cancel
                </button>
                <button (click)="submitFeedback()"
                    [disabled]="feedbackObservations().trim().length < 30 || feedbackRecommendations().trim().length < 30 || (feedbackComments().trim().length > 0 && feedbackComments().trim().length < 30)"
                    class="px-6 py-2.5 rounded-[10px] text-[13px] font-bold bg-[#7C3AED] text-white hover:bg-[#6D28D9] active:scale-95 transition-all shadow-md disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer">
                    Submit Feedback
                </button>
            </div>
        </div>
    </div>
    }
</div>